/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const AccountList = zod.strictObject({
    id: zod.number(),
    name: zod.string().min(1),
    created_at: zod.iso.datetime({ offset: true }),
    updated_at: zod.iso.datetime({ offset: true }),
});

export type AccountList = zod.input<typeof AccountList>;
export type AccountListOutput = zod.output<typeof AccountList>;
